module.exports = __webpack_public_path__ + "media/images/gallery/constellations/snr_layer_on-308ce018805b462b00ed607b2d04e096.jpg";